/**
 * @generated SignedSource<<a4cadc5fcdc43743c7cb407a0209e5e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type DuplicateProjectInput = {
  projectId?: string | null;
  projectColor?: string | null;
  customProjectId?: string | null;
  duplicateSettings?: boolean | null;
  duplicateTasks?: boolean | null;
  duplicatePhases?: boolean | null;
  duplicateProjectPersons?: boolean | null;
  duplicateExpenses?: boolean | null;
  duplicateColor?: boolean | null;
  duplicatePlaceholders?: boolean | null;
  duplicatePlaceholderAllocations?: boolean | null;
  duplicateAllocations?: boolean | null;
  duplicateRetainerPeriods?: boolean | null;
  name?: string | null;
  projectStartDay?: number | null;
  projectStartMonth?: number | null;
  projectStartYear?: number | null;
  projectEndDay?: number | null;
  projectEndMonth?: number | null;
  projectEndYear?: number | null;
  useManualAllocations?: boolean | null;
  budgetType?: BUDGET_TYPE | null;
  budget?: number | null;
  clientId?: string | null;
  clientContactId?: string | null;
  salespersonId?: string | null;
  baselineWinChance?: number | null;
  status?: PROJECT_STATUS | null;
  sageIntacctLocationEntityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type duplicateProjectMutation$variables = {
  input: DuplicateProjectInput;
};
export type duplicateProjectMutation$data = {
  readonly duplicateProject: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly project: {
      readonly node: {
        readonly id: string;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly status: PROJECT_STATUS | null;
        readonly baselineWinChance: number | null;
        readonly useBaseline: boolean | null;
        readonly salesperson: {
          readonly id: string;
        } | null;
        readonly name: string | null;
        readonly isJiraProject: boolean | null;
        readonly projectColor: string | null;
        readonly isInProjectGroup: boolean | null;
        readonly billable: boolean | null;
        readonly budgetType: BUDGET_TYPE | null;
        readonly projectGroupId: string | null;
        readonly sprintTimeBox: boolean | null;
        readonly useManualAllocations: boolean | null;
        readonly harvestProject: {
          readonly id: string;
        } | null;
        readonly statusColumnsV2: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly projectGroupStatusColumnId: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly projectPersons: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly isContactPerson: boolean | null;
              readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly profilePictureId: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type duplicateProjectMutation = {
  variables: duplicateProjectMutation$variables;
  response: duplicateProjectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateProjectPayload",
    "kind": "LinkedField",
    "name": "duplicateProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectTypeEdge",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineWinChance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "salesperson",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJiraProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useManualAllocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HarvestProjectType",
                "kind": "LinkedField",
                "name": "harvestProject",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v3/*: any*/)
                ],
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectGroupStatusColumnId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "contactsOnly",
                    "value": true
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isContactPerson",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "duplicateProjectMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicateProjectMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "49cdeefe9a14db90e7b71c2ba2d2fb05",
    "id": null,
    "metadata": {},
    "name": "duplicateProjectMutation",
    "operationKind": "mutation",
    "text": "mutation duplicateProjectMutation(\n  $input: DuplicateProjectInput!\n) {\n  duplicateProject(input: $input) {\n    errors\n    project {\n      node {\n        id\n        companyProjectId\n        customProjectId\n        status\n        baselineWinChance\n        useBaseline\n        salesperson {\n          id\n        }\n        name\n        isJiraProject\n        projectColor\n        isInProjectGroup\n        billable\n        budgetType\n        projectGroupId\n        sprintTimeBox\n        useManualAllocations\n        harvestProject {\n          id\n        }\n        statusColumnsV2(first: 1000000) {\n          edges {\n            node {\n              id\n              projectGroupStatusColumnId\n            }\n          }\n        }\n        projectPersons(first: 1000000, contactsOnly: true) {\n          edges {\n            node {\n              id\n              isContactPerson\n              person {\n                id\n                firstName\n                lastName\n                profilePictureId\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1532548a7055fcc4bda87c7574850caa";

export default node;
